import React from 'react';
import {
  formatCompactAbbrev,
  formatCurrency,
  formatCurrencyCompactAbbrev,
  formatCurrencyFull,
  formatNumber,
  formatNumberFull,
  formatNumberWithLocale,
  formatPercentage,
  formatPercentageFull,
  formatPercentageWhole,
} from '../../utils/FormatUtils';
import { NumericValueWithTooltip } from './NumericValueWithTooltip';

export function renderCompactAbbrevCell(value: number | null | undefined): React.ReactNode {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '—';
  return (
    <NumericValueWithTooltip
      display={formatCompactAbbrev(n)}
      fullValue={formatNumberFull(n)}
      align="center"
    />
  );
}

export function renderCurrencyCompactCell(value: number | null | undefined): React.ReactNode {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '—';
  return (
    <NumericValueWithTooltip
      display={formatCurrencyCompactAbbrev(n)}
      fullValue={formatCurrencyFull(n)}
      align="center"
    />
  );
}

export function renderLocaleNumberCell(
  value: number | null | undefined,
  maximumFractionDigits = 0,
): React.ReactNode {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return (
    <NumericValueWithTooltip
      display={formatNumberWithLocale(n, maximumFractionDigits)}
      fullValue={formatNumberFull(n)}
      align="center"
    />
  );
}

export function renderRoundedNumberCell(
  value: number | null | undefined,
  fractionDigits = 2,
): React.ReactNode {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return (
    <NumericValueWithTooltip
      display={n.toFixed(fractionDigits)}
      fullValue={formatNumberFull(n)}
      align="center"
    />
  );
}

export function renderFormatNumberCell(value: number | null | undefined): React.ReactNode {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '—';
  return (
    <NumericValueWithTooltip display={formatNumber(n)} fullValue={formatNumberFull(n)} align="center" />
  );
}

export function renderFormatCurrencyCell(value: number | null | undefined): React.ReactNode {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '—';
  return (
    <NumericValueWithTooltip display={formatCurrency(n)} fullValue={formatCurrencyFull(n)} align="center" />
  );
}

export function renderFormatPercentageCell(value: number | null | undefined): React.ReactNode {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '—';
  return (
    <NumericValueWithTooltip
      display={formatPercentage(n)}
      fullValue={formatPercentageFull(n)}
      align="center"
    />
  );
}

export function renderFormatPercentageWholeCell(value: number | null | undefined): React.ReactNode {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '—';
  return (
    <NumericValueWithTooltip
      display={formatPercentageWhole(n)}
      fullValue={formatPercentageFull(n)}
      align="center"
    />
  );
}
